import { CAREER_IMAGES } from "@/lib/utils";

const CareerImageGrid = () => {
  return (
    <div className="relative w-full max-w-[800px] mx-auto">
      {CAREER_IMAGES.map((img, index) => (
        <img
          key={index}
          src={img.src}
          alt={img.alt}
          className={img.className}
          style={img.style}
        />
      ))}
    </div>
  );
};

export default CareerImageGrid;
